module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/vacancies-html.json
// module id = 766
// module chunks = 221524990641428